/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function DataSourceItemFromJSON(json) {
    return DataSourceItemFromJSONTyped(json, false);
}
export function DataSourceItemFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        tagIds: !exists(json, 'tagIds') ? undefined : json['tagIds'],
        skip: !exists(json, 'skip') ? undefined : json['skip'],
        expression: !exists(json, 'expression') ? undefined : json['expression'],
        constantValue: !exists(json, 'constantValue') ? undefined : json['constantValue'],
        classNames: !exists(json, 'classNames') ? undefined : json['classNames'],
    };
}
export function DataSourceItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        tagIds: value.tagIds,
        skip: value.skip,
        expression: value.expression,
        constantValue: value.constantValue,
        classNames: value.classNames,
    };
}
